"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConnectedCardNotificationPanel = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _reactI18next = require("react-i18next");

var _reactRedux = require("react-redux");

var _createAction = require("../../redux/createAction");

var _models = require("../models");

var _INotification = require("../models/INotification");

var _notificationRegistry = require("../notificationRegistry");

var _CardNotificationPanel = require("./CardNotificationPanel");

/**
 * Maps the external (i.e. own) props and the state to the properties of the CardNotificationPanel control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (ICardNotificationPanelProps) for the CardNotificationPanel control
 */
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var isOpen = ownProps.isOpen;

  var notifications = _notificationRegistry.notificationRegistry.getNotifications(state);

  var cardNotifications = notifications ? (0, _filter.default)(notifications).call(notifications, function (notification) {
    return notification.type === _INotification.NotificationType.card;
  }) : null;
  return {
    isOpen: isOpen,
    notifications: cardNotifications
  };
};
/**
 * Maps the dispatch actions to the props for the CardNotificationPanel control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (ICardNotificationPanelProps) for the CardNotificationPanel control
 */


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onDismiss: (0, _createAction.createAction)(_models.NotificationsActions.dialogCanceled, dispatch),
    raiseAction: function raiseAction(actionName, payload) {
      (0, _createAction.createAction)(actionName, dispatch)(payload);
    }
  };
};
/**
 * A redux connected CardNotificationPanel control.
 * @description Supports translation
 */


var ConnectedCardNotificationPanel = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.translate)('Notifications')(_CardNotificationPanel.CardNotificationPanel));
exports.ConnectedCardNotificationPanel = ConnectedCardNotificationPanel;